import { OffersBundleApiClient } from '@fourthwall/services/dist/OffersBundleApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useBundleOfferArchivedMutation = createMutationHook(
  OffersBundleApiClient.archiveOfferBundle,
  {
    mutationKey: ['archiveOfferBundle'],
  },
)
